import { motion } from "framer-motion";

export default function Footer({ t, onEnquire }) {
  return (
    <footer data-testid="footer" className="bg-ivory pt-20 md:pt-32 pb-10 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <motion.button
          data-testid="footer-enquire-btn"
          onClick={() => onEnquire("stay")}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="block w-full text-left group"
        >
          <span className="block font-serif font-light text-pine text-[13vw] md:text-[9vw] leading-[0.95] tracking-tight group-hover:text-terracotta transition-colors duration-500">
            {t.footer.line1}
          </span>
          <span className="block font-serif font-light italic text-outline text-[13vw] md:text-[9vw] leading-[0.95] tracking-tight group-hover:text-terracotta group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
            {t.footer.line2}
          </span>
        </motion.button>

        <div className="mt-16 md:mt-24 pt-8 border-t border-pine/10 flex flex-col md:flex-row justify-between gap-6">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-pine/60">
              {t.footer.locationLine}
            </p>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-pine/40 mt-1">53.1610° N, 4.3582° W</p>
          </div>
          <div className="md:text-right">
            <a
              data-testid="footer-email-link"
              href="mailto:tom@property-owl.com"
              className="font-serif text-xl md:text-2xl text-pine hover:text-terracotta transition-colors duration-300"
            >
              tom@property-owl.com
            </a>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-pine/40 mt-2">
              © {new Date().getFullYear()} {t.footer.copyright}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
